module.exports = __webpack_public_path__ + "1.f60b90ff10502ff3b3ac.jpg";